import { CurrencyCode } from '../types/API'
import { parseString } from './dataTransformer'

const currencyMap = new Map<CurrencyCode, string>([
  [CurrencyCode.GBP, '&#163;'],
  [CurrencyCode.EUR, '&#8364;'],
])
export const getCurrencySymbol = (code: CurrencyCode): string => {
  const symbol = currencyMap.get(code)
  if (symbol) {
    return parseString(symbol)
  }
  return ''
}

export const formatCurrency = (
  amount: number,
  currency?: CurrencyCode,
  withoutDecimals?: boolean,
): string => {
  if (!amount) return ''

  const hasDecimals = amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const noDecimals = amount.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const final = withoutDecimals ? noDecimals : hasDecimals

  return `${getCurrencySymbol(currency || CurrencyCode.GBP)}${final}`
}

export const valueToCurrency = (
  value: string,
  currency: CurrencyCode,
): string => {
  const trimmedPrice = value.trim()
  return getCurrencySymbol(currency) + trimmedPrice
}

export const roundDecimalValue = (
  input: string,
  trailingZerosOptional: boolean = true,
): string => {
  const noDecimals = input.indexOf('.') === -1

  // if number has no decimals and trailing zeros are
  // optional, then we can just return the number
  if (noDecimals && trailingZerosOptional) {
    return parseFloat(input).toString()
  }
  // else force 2 decimal places
  return parseFloat(input).toFixed(2)
}

// Designed to be a catch-all money/currency formatter to replace the above two eventually
export const formatMoney = (
  value: number | string,
  currency?: CurrencyCode,
): string => {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const formattedValue = formatter.format(numberValue)
  const symbol = currency ? getCurrencySymbol(currency) : ''

  if (formattedValue.endsWith('.00')) {
    return `${symbol}${formattedValue.slice(0, -3)}`
  }

  return `${symbol}${formattedValue}`
}
